import styled from 'styled-components';

const AppHolder = styled.div`

  .main-app {
    font-family: 'Quicksand', sans-serif;
    display: grid;
    grid-template-columns: auto;
    grid-template-rows: auto 1fr;
    gap: 0px 0px;
    grid-template-areas: 
    'header'
    'news'
    'main';
    background-color: white;
    overflow: hidden;
  }
  .main-content {
    background-image: linear-gradient(to top, #fdfdfc, #d2d9df);
    grid-area: main;
    display: grid;
    grid-template-columns: 1fr;
    grid-template-rows: auto 1fr;
    gap: 0px 0px;
    grid-template-areas: 
    'content'
    'footer';
    z-index: 10;
  }
  .content-wrapper {
    padding: 10px 25px 25px 25px;
    max-width: 1920px;
    margin: 0 auto;

    @media only screen and (max-width: 548px) {
      padding: 10px 5px 25px 5px;
    }
	}
  .content {
    overflow-x: hidden;
    max-width: 1920px;
    &__full {
      position: relative;
      display: block;
      width: 100%;
      margin: 0 0 10px 0;
    }
    &__left {
      display:inline-block;
      margin: 10px 0 10px 0;
      width: calc(75% - 10px);
      @media only screen and (max-width: 1050px) {
        width: 100%;
      }
    }
    &__right {
      display:inline-block;
      max-width: 24%;
      width: 24%;
      margin: 10px 0px 10px 19px;
      vertical-align: top;
      @media only screen and (max-width: 1050px) {
        margin-left: 0;
        width: 100%;
        max-width: 100%;
      }
    }
    &__carousel {
      position: relative;
      width: 100%;
      min-height: 340px;
      margin-bottom: 20px;

      &.constrain {
        min-height:340px;
        transition: 0.5s ease-in;
      }
      &.expanded {
        min-height: 890px;
        transition: 0.5s ease-in;
      }
    }
  }
  .show {
    visibility: visible;
    opacity: 1;
    transition: 0.5s ease-in;
  }

  .hide {
    display: none; 
  }

  .expanded {
    visibility: visible;
    opacity: 1;
    transition: 1s ease-in;
  }

  .hidden {
    visibility: hidden;
    opacity: 0;
    transition: visibility 0.5s, opacity 0.5s linear;
  }

  .backdrop {
    grid-area:main;
    height:100%;
    width: 100%;
    background-color: black;
    opacity: 0.5;
    z-index:12;
    @media only screen and (max-width: 920px) {
      height:calc(100% - 263px);
    }
  }

  .video-live-label {
    font-family: "Open Sans", sans-serif;
    position: relative;
    display: inline-block;
    margin-right: 20px;
    font-size: 12px;
    font-weight: 700;
    text-transform: uppercase;
    border-radius: 2px;
    background: #FFF;
    color: black;
    padding: 0px 5px 0px 20px !important;
    text-align: left;
    vertical-align: top;
    line-height: 20px;
    margin-top:5px;
    min-height: auto !important;

    span {
      vertical-align: top;
      white-space: nowrap;
    }

    img {
      position: absolute;
      display: inline-block;
      width: 24px;
      top: -2px;
      left: -2px;
      filter: invert(8%) sepia(90%) saturate(7493%) hue-rotate(11deg) brightness(94%) contrast(116%);
      height: auto !important;
      min-height: auto !important;
      transition: all 0.4s ease-in;
      animation: pulse-opacity 3s infinite;
      @media only screen and (max-width: 548px) {
          width: 30px !important;
          top: -5px;
          left: -5px;
      }
    }
  }

  .hn__Header {
    color: #fdfdfc;
    font-family: 'Quicksand', sans-serif;
    display: flex;
    justify-content: space-between;
    background: #5f7586 url(/static-assets/theme/svg/left-decoration.svg) center left -2px no-repeat;
    background-size: auto 110%;
    padding: 8px 20px 8px 40px;
    border-radius: 2em;
    border: 0;
    text-transform: uppercase;
    margin: 20px 0px 20px 0px !important;
    font-size: 24px;
    @media only screen and (max-width: 548px) {
			font-size: 15px;
		}
    a {
      color: white;
      font-weight: 600;
      font-size: 17px;
      vertical-align: middle;
      position: relative;
      line-height: 1;
      top: 4px;
      @media only screen and (max-width: 548px) {
        font-size: 14px;
        top: 3px;
      }
      svg {
        color: #d2d9df;
        position: relative;
        vertical-align: middle;
        top: -0.1em;
        right: 0;
        line-height: 1;
        margin-left: 10px;
        font-size: 18px;
        opacity: 0.8;
        transition: all 0.2s ease-in;
        @media only screen and (max-width: 548px) {
          margin-left: 5px;
          font-size: 14px;
        }
      }
    }
  }

  .hn__Header-bottom {
    color: #fdfdfc;
    font-family: 'Quicksand', sans-serif;
    display: flex;
    justify-content: flex-end;
    background: #5f7586 url(/static-assets/theme/svg/left-decoration.svg) center left -2px no-repeat;
    background-size: auto 110%;
    padding: 14px 20px 12.29px 40px;
    border-radius: 2em;
    border: 0;
    text-transform: uppercase;
    margin: 20px 0px 20px 0px !important;
    font-size: 24px;
    @media only screen and (max-width: 548px) {
			font-size: 15px;
		}
    a {
      color: white;
      font-weight: 600;
      font-size: 17px;
      vertical-align: middle;
      line-height: 1;
      @media only screen and (max-width: 548px) {
        font-size: 14px;
        top: 3px;
      }
      svg {
        color: #d2d9df;
        position: relative;
        vertical-align: middle;
        top: -0.1em;
        right: 0;
        line-height: 1;
        margin-left: 10px;
        font-size: 18px;
        opacity: 0.8;
        transition: all 0.2s ease-in;
        @media only screen and (max-width: 548px) {
          margin-left: 5px;
          font-size: 14px;
        }
      }
    }
  }

  .mobile-only {
    display: none !important;
    @media only screen and (max-width: 920px) {
      display: block !important;
    }
  }

  .loading {
    height: 0;
    width: 20px;
    padding: 10px;
    border: 6px solid #ccc;
    border-right-color: #888;
    border-radius: 22px;
    animation: rotate 1s infinite linear;
    position: relative;
    display: inline-block;
    top: 7px;
    left: 0;
    margin-right: 10px;
    margin-left: -35px;
  }
  // Animations
  @keyframes rotate {
    100% {
      -webkit-transform: rotate(360deg);
    }
  }

  @keyframes pulse-opacity {
    0% {
      opacity: .25;
    }
    50% {
      opacity: 1;
    }
    100% {
      opacity: .25;
    }
  } 

  .expandDown {
      &-appear {
        display:block;
        position: absolute;
        top: 75px;
        width: 100%;
        transition: top 0.32s ease-in;
      }
      &-collapse {
        position: absolute;
        top: -800px;
        width: 100%;
        transition: top 0.32s ease-in;
      }
  }

  .expandDownS {
    &-appear {
      display:block;
      position: absolute;
      top: 75px;
      width: 100%;
      transition: top 0.15s ease-in;
    }
    &-collapse {
      position: absolute;
      top: -100px;
      width: 100%;
      transition: top 0.15s ease-in;
    }
  }
 
  .expandLeft {
    &-appear {
      display:block;
      top: 90px;
      left: 0px;
      transition: left 0.26s ease-in;
    }
    &-collapse {
      left: -400px;
      transition: left 0.26s ease-in;
    }
  }

  .yt-list-container {
		@media only screen 
		and (min-device-width: 768px) 
		and (max-device-width: 1024px) 
    and (orientation: landscape)
		and (-webkit-min-device-pixel-ratio: 1) {
			min-height: 430px;
		}

    @media only screen 
		and (min-device-width: 768px) 
		and (max-device-width: 1024px) 
    and (orientation: portrait)
		and (-webkit-min-device-pixel-ratio: 1) {
			min-height: 380px;
		}
	}
  .jw-state-idle .jw-controls {
		background: transparent !important;
	}

  .featured-container__big-item .jw-error-text {
    /* iphone 5/SE START */
    @media only screen and (max-width: 320px) {
      font-size: 12.1px;
    }
    /* iphone 5/SE END */
    @media only screen and (min-width: 321px) and (max-width: 1024px) {
      font-size: 15.6px;
    }
    height: 1.4em;
    overflow: hidden;
    font-size: 30px;
    background-color: black;
    opacity: 0.5;
    text-align: center;
  }
  .featured-container__big-item .jwplayer .jw-error-msg  {
    align-items: center;
    background-color: transparent;
    padding: 0px;
    width: 70%;
    top: 70%;
  }
  .featured-container__big-item .jw-error-msg .jw-icon.jw-reset {
    display: none;
  }
  h1.page-title {
		font-family: "Quicksand", sans-serif;
		font-size: 24px;
		font-weight: 700;
		line-height: 1.2;
		background-color: #726b55;
		color: #fff;
		text-align:left !important;
		width: 100%;
		padding: 12px 12px 12px 25px;
		margin: 0;
    @media only screen and (max-width: 767px) {
			font-size: 20px;
			padding: 10px 10px;
		}
	}
`;

export default AppHolder;